module.exports = __webpack_public_path__ + "static/media/9-Y.db741406.mp3";